export const BE_CONFIG = `${process.env.REACT_APP_BE_URL}`;
// "http://localhost:4000";
